import { useMemo } from "react";

import Box from "ds/components/Box";
import { RunWorkerMetrics } from "types/generated";

import {
  getSlowestHookGroups,
  getSlowestItemsScaleSeconds,
  getSlowestProviderGroups,
  getSlowestResourceGroups,
} from "./utils";
import RunObservabilitySlowestItemsCard from "./Card";

type RunObservabilitySlowestItemsProps = {
  workerMetrics: RunWorkerMetrics;
};

const RunObservabilitySlowestItems = ({ workerMetrics }: RunObservabilitySlowestItemsProps) => {
  const { slowestResources, slowestHooks, slowestProviders, scaleSeconds } = useMemo(() => {
    const resources = getSlowestResourceGroups(workerMetrics.states);
    const hooks = getSlowestHookGroups(workerMetrics.states);
    const providers = getSlowestProviderGroups(workerMetrics.slowestProviders);

    return {
      slowestResources: resources,
      slowestHooks: hooks,
      slowestProviders: providers,
      scaleSeconds: getSlowestItemsScaleSeconds([...resources, ...hooks, ...providers]),
    };
  }, [workerMetrics]);

  return (
    <Box grid gridTemplate="repeat(auto-fit, minmax(30rem, 1fr))" gap="large" fullWidth>
      <RunObservabilitySlowestItemsCard
        title="Slowest resources"
        emptyTitle="No resource timings for this run"
        emptyPhaseTitle="No resource timings for this phase"
        groups={slowestResources}
        scaleSeconds={scaleSeconds}
      />
      <RunObservabilitySlowestItemsCard
        title="Slowest hooks"
        emptyTitle="No hook timings for this run"
        emptyPhaseTitle="No hook timings for this phase"
        groups={slowestHooks}
        scaleSeconds={scaleSeconds}
      />
      <RunObservabilitySlowestItemsCard
        title="Slowest provider installs"
        emptyTitle="No provider install timings for this run"
        groups={slowestProviders}
        scaleSeconds={scaleSeconds}
      />
    </Box>
  );
};

export default RunObservabilitySlowestItems;
